import React from 'react';
import { Link } from 'react-router-dom';
import GalleryCarousel from '../Components/site/GalleryCarousel';
import useSiteContent from '../hooks/useSiteContent';

export default function GalleryPage() {
  const { siteContent } = useSiteContent();

  return (
    <main className="page">
      <section className="page-section page-section--intro">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{siteContent.galleryPage.tag}</span>
          <h1>{siteContent.galleryPage.title}</h1>
          <p>{siteContent.galleryPage.text}</p>
        </div>
      </section>

      <section className="page-section">
        <GalleryCarousel />
      </section>

      <section className="page-section">
        <div className="cta-banner">
          <div>
            <span className="section-heading__eyebrow">Brows Jungle</span>
            <h2>{siteContent.pricingPage.title}</h2>
          </div>
          <Link to="/pricing" className="button button--primary">
            {siteContent.common.pricing}
          </Link>
        </div>
      </section>
    </main>
  );
}
